import { Customization } from "@aitisal/contracts/restaurant/menu";
import { cartStore as sharedCartStore, useCart as useSharedCart } from "@aitisal/ui";
import { useSession } from "./sessionStore";
import { useRestuarantDetails } from "./stores";

export const cartStore = sharedCartStore;

function restructureCustomizations(
  customizations: Customization[] | undefined,
): Customization[] {
  return (customizations
    ?.map((customization: any) => {
      const rawOptions =
        customization.options ?? customization.customizationOptions ?? [];

      const customizationOptions =
        rawOptions.length > 0
          ? rawOptions.map((option: any) => ({
              customizationOptionId:
                option.customizationOptionId ?? option.id ?? "",
              position: option.position || 1,
              price: option.price || 0,
              quantity: option.quantity ?? 1,
              name: option.name,
              ...(option.itemId ? { itemId: option.itemId } : {}),
              ...(option.itemTax !== undefined
                ? { itemTax: option.itemTax }
                : {}),
            }))
          : [];

      return {
        ...customization,
        customizationOptions,
      };
    })
    .filter(Boolean) as Customization[]) || [];
}

export function useCart() {
  const { restaurant } = useRestuarantDetails();
  const { restaurantId, pointOfOrder } = useSession();
  const cartKey = restaurantId + pointOfOrder?.salesChannelId;

  const shared = useSharedCart({ restaurant, cartKey });

  const addToCart = (
    item: any,
    customizations: Customization[],
    quantity?: any,
    variant?: { variantId: string; sku?: string; barcode?: string },
  ) =>
    shared.addToCart(
      item,
      restructureCustomizations(customizations),
      quantity,
      variant,
    );

  return {
    ...shared,
    addToCart,
    cartKey,
  };
}
